import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {X_SMALL_TEXT_PX, DARK_NAVY_FONT_COLOR,} from 'src/styles/fonts/MCFontConstants';

export const OrdersListViewContainer = styled.div`
    margin-top: 10px;
    ${media.mobileDevice`
        display: none;
    `}
`;

export const SetContainer = styled.div`
    font-family: AvenirNextWorld Demi;
    background: #ffffff;
    border: 0.800000011920929px solid #707070;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    width: ${(props) => (props.width ? props.width : '41px')};
    height: 18px;
    opacity: 0.7;
    font-size: 10px;
    color: #3c3c3c;
    display: ${(props) =>
        props.isSetsVisible ? props.isSetsVisible : 'block'};
`;

export const DateView = styled.div`
    display: flex;
    flex-direction: row;
`;

export const ApplyButton = styled.div`
    margin-left: 20px;
    background-color: red;
`;

export const DateText = styled.p`
    color: #000000;
    font-size: 18px;
    margin-left: 15px;
    margin-right: 15px;
`;

export const BottomText = styled.p`
    color: #000000;
    font-size: 20px;
    margin-right: 15px;
`;

export const Title = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: ${X_SMALL_TEXT_PX};
    color: ${({ color }) => (color ? color : DARK_NAVY_FONT_COLOR)};
    margin-top: 4px;
`;

export const FlexColumnContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
